export default __webpack_public_path__ + "static/media/events.4b3d33ff.svg";